(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-cabinet"] && !Shopify.designMode) return;
  try {
    
(function() {
  var cabinetLayout = [0, 2, 9, 12, 14, 19, 21, 7, 4, 6, 1, 17, 13, 22, 10, 15, 8, 3, 20, 18, 23, 16, 5];
  var cabinetCurrentProduct = null;
  var cabinetList = null;

  function cabinetShowProduct(product) {
	cabinetCurrentProduct = product;

	var element = document.createElement("div");
	element.className = "cabinet--product-info-product-inner";

	var linkWithVariant = product.du;
	if (product.vi) {
		linkWithVariant += "?variant=" + product.epi;
	}

	var imageLink = document.createElement("a");
	imageLink.className = "cabinet--product-info-image-link";
	imageLink.href = linkWithVariant;
	var image = document.createElement("img");
	//image.src = product.cprops && product.cprops.productImage ? product.cprops.productImage : product.iu;
	image.src = product.iu;

	
	imageLink.appendChild(image);
	element.appendChild(imageLink);

	var brand = document.createElement("p");
	brand.className = "cabinet--product-info-brand";
	brand.textContent = product.bt;
	element.appendChild(brand);

	var titleLink = document.createElement("a");
	titleLink.className = "cabinet--product-info-title-link";
	titleLink.href = linkWithVariant;
	var title = document.createElement("h2");
	title.textContent = product.dt;

	titleLink.appendChild(title);
	element.appendChild(titleLink);

	var variationString = (product.ct ? product.ct : "") + (product.vi ? " " + product.vi : "");

	var variation = document.createElement("p");
	variation.className = "cabinet--product-info-variation";
	variation.textContent = variationString;
	element.appendChild(variation);
	
	var price = document.createElement("p");
	price.className = "cabinet--product-info-price";
	price.textContent = "$" + product.pr.toFixed(2);
	element.appendChild(price);

	var productInfo = document.querySelector(".cabinet--product-info-product-inner");
	productInfo.parentNode.replaceChild(element, productInfo);

	var mobileProductList = document.querySelector(".cabinet--mobile--products-list");
	var hasPoke = document.querySelector(".cabinet--mobile--poke");
	for (var i = 0; i < cabinetList.listcontents.length && i < 23; i++) {
		var idx = hasPoke ? i + 1 : i;                                                        
		if (cabinetList.listcontents[i] == product) {
			mobileProductList.children[idx].className = "cabinet--mobile--products-product is-current";
		} else {
			mobileProductList.children[idx].className = "cabinet--mobile--products-product";
		}
	}                                                        
  }

  function cabinetCreateProduct(product) {
	var element = document.createElement("div");
	element.className = "cabinet--product-inner";
    if (product.cprops && product.cprops.cabinetImage) {
		element.style["background-image"] = "url('" + product.cprops.cabinetImage + "')";  
	} else {
		element.style["background-image"] = "url('" + product.iu + "')";  
	}
	element.addEventListener("click", function(e) {
		cabinetShowProduct(product);
		if(window.innerWidth <= 800) {
            var scrollPos = document.querySelector(".cabinet--mobile--products").getBoundingClientRect().top + window.scrollY;
			window.scrollTo({
 				top: scrollPos,
  				left: 0,
  				behavior: "smooth"
			});
        }                                   
	});
	return element;
  }
                                   
  function cabinetCreateMobileProduct(product) {
	var element = document.createElement("div");
	element.className = "cabinet--mobile--products-product";
	if (product.cprops && product.cprops.cabinetImage) {
		element.style["background-image"] = "url('" + product.cprops.cabinetImage + "')";  
	} else {
		element.style["background-image"] = "url('" + product.iu + "')";  
	}
	                                 
	element.addEventListener("click", function(e) {
		cabinetShowProduct(product);
    });
	return element;
  }
                                    
  function showPokeDialog(e) {
	e.preventDefault();
	document.querySelector(".cabinet--poke--dialog").style["display"] = "flex";
  }

  function cabinetInit(swat) {
	document.querySelector(".cabinet--product-info-product-prev").addEventListener("click", function(e) {
		var currentIdx = cabinetList.listcontents.indexOf(cabinetCurrentProduct);
		var nextIdx = currentIdx === 0 ? cabinetList.listcontents.length - 1 : currentIdx - 1;
		cabinetShowProduct(cabinetList.listcontents[nextIdx]);
	});

	document.querySelector(".cabinet--product-info-product-next").addEventListener("click", function(e) {
		var currentIdx = cabinetList.listcontents.indexOf(cabinetCurrentProduct);
		var nextIdx = currentIdx === cabinetList.listcontents.length - 1 ? 0 : currentIdx + 1;
		cabinetShowProduct(cabinetList.listcontents[nextIdx]);
	});

	document.querySelector(".cabinet--product-info-product-remove").addEventListener("click", function(e) {
		console.log("deleting", cabinetList.lid, cabinetCurrentProduct);
		swat.deleteFromList(cabinetList.lid, {
          epi: cabinetCurrentProduct.epi,
          empi: cabinetCurrentProduct.empi,
          du: cabinetCurrentProduct.du
        }, 
		function(deletedListItem) {
			// For now
			window.location.href = window.location.href;
		}, function(err) {
			console.log(err);
		});
	});

	document.querySelector(".cabinet--product-info-product-atc").addEventListener("click", function(e) {
		jQuery.post("/cart/add.js", 
			{items: [{id: cabinetCurrentProduct.epi, quantity: 1}]},
			function () { 
				// For now. Need to figure out how to just update the cart quantity		
				window.location.href = window.location.href; 
			},
			"json"
		);
	});                                   

	var allToCartButton = document.querySelector(".cabinet--add-all-to-cart-ctx");
	allToCartButton.addEventListener("click", function(e) {
		allToCartButton.classList.add("disabled");
		var cartItems = [];
		var resultsDone = [];
		var resultsFailed = [];                                   
                                   
		var addNextItemToCartOrFinish = function () {
			var item = cartItems.pop();                                   
			if (item) {
				jQuery.post("/cart/add.js", {items: [item]}, null, "json").then(function() {
					resultsDone.push(item);
				}).fail(function(err) {
					resultsFailed.push(item);
				}).always(function() {
					console.log(resultsDone.length, resultsFailed.length);
					if (cartItems.length) {
                    	addNextItemToCartOrFinish();
                    } else {
                    	var feedback = document.querySelector(".cabinet--add-all-to-cart-feedback");
						if (resultsFailed.length) {
							feedback.innerText = "Most products were added to your cart, except for those that are currently sold out, or those that were already in your cart";                                   
						}
						jQuery.get("/cart.js", null, null, "json").done(function(result) {
							jQuery("[data-site-header-main]").trigger("cartcount:update", {
                  				response: result
                			});
						});
						allToCartButton.style["display"] = "none";				
						feedback.style["display"] = "block";
                    }									
				});
			}
		};                                   

		for (var j = 0; j < cabinetList.listcontents.length; j++) {
			var cartItem = {id: cabinetList.listcontents[j].epi, quantity: 1};
			cartItems.push(cartItem);			
        }
		
		addNextItemToCartOrFinish();			        
	});
                                                            
	document.querySelector(".cabinet--poke").addEventListener("click", function(e) {
		showPokeDialog(e);
	});

    document.querySelector(".cabinet--mobile--poke").addEventListener("click", function(e) {
		showPokeDialog(e);                                                                             
	});
                                                                             
	document.querySelector(".cabinet--poke--dialog--close").addEventListener("click", function(e) {
		e.preventDefault();
		document.querySelector(".cabinet--poke--dialog").style["display"] = "none";
	});
	

	var main = document.querySelector(".cabinet--container .home-section--content");
	main.classList.remove("is-loading");
  }

  function processList(swat) {
	var cabinetProductPlaceholders = document.querySelectorAll(".cabinet--closet .cabinet--product");

    console.log('cabinetList', cabinetList);

	if (cabinetList) {
    	if (cabinetList.listcontents && cabinetList.listcontents.length) {
          cabinetList.listcontents.sort(function(a, b){
            return a.cts < b.cts ? -1 : 1;
          });
                                

          var emptyList = document.querySelector(".cabinet--product-info-empty");
          emptyList.style["display"] = "none";
          var productInfo = document.querySelector(".cabinet--product-info-product");
          productInfo.style["display"] = "block";
          var productCount = document.querySelector(".cabinet--count");
          productCount.textContent = "Products (" + cabinetList.listcontents.length + ")";
          var productCountMobile = document.querySelector(".cabinet--mobile--products-count");
          productCountMobile.textContent = "Products in routine (" + cabinetList.listcontents.length + ")";

          var productMobileList = document.querySelector(".cabinet--mobile--products-list");                                                 
          for (var j = 0; j < cabinetList.listcontents.length && j < 23; j++) {
              var productEl = cabinetCreateProduct(cabinetList.listcontents[j]);
              cabinetProductPlaceholders[cabinetLayout[j]].appendChild(productEl);
              var productMobileEl = cabinetCreateMobileProduct(cabinetList.listcontents[j]);
              productMobileList.appendChild(productMobileEl);
          }
		}

        if (cabinetList.listcontents && cabinetList.listcontents.length) {
        	cabinetShowProduct(cabinetList.listcontents[0]);
		} else {
        	document.querySelector(".cabinet--product-info-empty").style.display = "block";
        }                                      
     }
                                                                      
	 cabinetInit(swat);
  }

  function swymCallbackFn(swat) {
	console.log("Fetching lists..");
	swat.fetchLists({
		callbackFn: function(lists) {
			console.log("Received lists", lists);
			if (lists && lists.length) {
				for (var i = 0; i < lists.length; i++) {
                	if (lists[i].lname === "My cabinet") {
                    	cabinetList = lists[i];
                        break;
					}
				}				
			}

			if (cabinetList) {
				processList(swat);
			} else {
				swat.createList({"lname": "My cabinet"}, function(list) {
                    console.log("created!", list);
                    cabinetList = list;
                    processList(swat);
				});
			}

		},
		errorFn: function(err) {
			console.log(err);
		}
	});
  }

  if(!window.SwymCallbacks) {
    console.log("Initiating callbacks");
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  console.log("Adding cabinet callback");
 //  if(document.body.classList.contains("is-customer")) {
	// window.SwymCallbacks.push(swymCallbackFn);
	// console.log("Adding cabinet callback");
 //  } else {
 //    var emptyList = document.querySelector(".cabinet--product-info-empty");
 //    emptyList.style["display"] = "block";
	// var main = document.querySelector(".cabinet--container .home-section--content");
	// main.classList.remove("is-loading");
	// var allToCartButton = document.querySelector(".cabinet--add-all-to-cart-ctx");
	// allToCartButton.classList.add("disabled");
	// var routineCTA = document.querySelector(".cabinet--routine-cta");
	// routineCTA.style["display"] = "none";
	// var recommendationsCTA = document.querySelector(".cabinet--recommendations-cta");
	// recommendationsCTA.style["display"] = "none";
 //  }

})();


  } catch(e) { console.error(e); }
})();
})();
